<script setup lang="ts">
import { useModal } from '~/composables/useModal'

const emit = defineEmits(['confirm', 'cancel'])
const modal = useModal()

function confirm() {
  emit('confirm')
  modal.close()
}

function cancel() {
  emit('cancel')
  modal.close()
}
</script>

<template>
  <UiAlertDialog v-model:open="modal.isOpen.value">
    <UiAlertDialogContent>
      <UiAlertDialogTitle class="text-4xl">
        {{ $t('Undo bull winner') }}
      </UiAlertDialogTitle>
      <UiAlertDialogFooter>
        <UiButton
          variant="success"
          size="huge"
          class="mr-auto"
          @click="confirm"
        >
          {{ $t('Yes') }}
        </UiButton>
        <UiButton
          variant="destructive"
          size="huge"
          @click="cancel"
        >
          {{ $t('No') }}
        </UiButton>
      </UiAlertDialogFooter>
    </UiAlertDialogContent>
  </UiAlertDialog>
</template>
